
















import { Component, Vue } from 'vue-property-decorator';
import { mapGetters, mapState } from 'vuex';

import LoginForm from '@/components/Auth/LoginForm.vue';

import NavBar from '@/components/Layout/NavBar.vue'
import AsideMenu from '@/components/Layout/AsideMenu.vue'
import { ServerResult } from './core/http/server_result';

@Component({
  computed: {
    ...mapState('ubic', [
      'token', 'actor'
    ]),
    ...mapGetters('ubic', [
      'isAuthenticated',
    ]),
  },
  components: {
    LoginForm,
    AsideMenu,
    NavBar
  }
})
export default class App extends Vue {
  public isAuthenticated!: boolean;
  public actor!: any;

  get menu () {
    const _menu: any = [
      'Заказы',
      [
        {
          to: { name: 'order-new' },
          icon: 'plus',
          label: 'Создать заявку',
          isHighlight: true
        },
        {
          to: { name: 'catalog' },
          icon: 'shopping-outline',
          label: 'Главная страница'
        },
        {
          to: { name: 'orders' },
          icon: 'cart-outline',
          label: 'История заказов'
        },
      ],
    ]
    return _menu.map((item: any) => {
      const _type = typeof item;
      if ((_type as string) === 'object') {
        item = item.map((child_item: any) => {
          if (child_item.permissions) {
            child_item = child_item.permissions.filter((role: string) => this.actor.roles.includes(role)).filter((i: any) => i).length > 0 ? child_item : null;
            if (child_item && child_item.props) {
              child_item.props[0] = child_item.props[0].map((prop: any) => {
                return !prop.permissions || prop.permissions.filter((role: string) => this.actor.roles.includes(role)).filter((i: any) => i).length > 0 ? prop : null;
              }).filter((i: any) => {return i});
            }
          }
          return child_item
        })
        if (item.length == 0) {
          item = null;
        } else {
          item = item.filter((i: any) => {return i})
        }
      }
      return item
    }).filter((i: any) => {return i})
  }

  created () {
    // noop
  }

}
